import { render } from "./mapControlsRecent.vue?vue&type=template&id=62322a91&scoped=true"
import script from "./mapControlsRecent.vue?vue&type=script&lang=js"
export * from "./mapControlsRecent.vue?vue&type=script&lang=js"

import "./mapControlsRecent.vue?vue&type=style&index=0&id=62322a91&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62322a91"]])

export default __exports__